import { render } from "./TNovoTipoAtividade.vue?vue&type=template&id=0cefb832&scoped=true"
const script = {}

import "./TNovoTipoAtividade.vue?vue&type=style&index=0&id=0cefb832&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cefb832"]])

export default __exports__